import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  Search, 
  Download, 
  Filter, 
  Database, 
  Shield, 
  Zap,
  Clock,
  TrendingUp,
  Mail
} from 'lucide-react';

const FeaturesSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const features = [
    {
      icon: Search,
      title: 'Präzise Suche',
      description: 'Filtern Sie nach Bundesland, Stadt und Branche. Finden Sie in Sekunden genau die Unternehmen, die Sie suchen.'
    },
    {
      icon: Download,
      title: 'Sofort-Export',
      description: 'Laden Sie Ihre Kontakte als CSV-Datei herunter und integrieren Sie sie direkt in Ihr CRM oder Ihre Marketing-Tools.'
    },
    {
      icon: Filter,
      title: 'Intelligente Filter',
      description: 'Mehrfachauswahl von Städten und Branchen. Kombinieren Sie Filter für maximale Präzision bei der Lead-Generierung.'
    },
    {
      icon: Database,
      title: 'Vollständige Daten',
      description: 'Name, Adresse, Telefon, E-Mail, Website – alle relevanten Informationen auf einen Blick.'
    },
    {
      icon: Shield,
      title: 'DSGVO-konform',
      description: 'Alle Daten werden DSGVO-konform erhoben und verarbeitet. Ihre Rechtssicherheit hat Priorität.'
    },
    {
      icon: Zap,
      title: 'Blitzschnell',
      description: 'Keine langen Ladezeiten. Unsere Plattform ist auf Performance optimiert – für Ihre Effizienz.'
    },
    {
      icon: Clock,
      title: 'Regelmäßig aktualisiert',
      description: 'Unsere Datenbank wird kontinuierlich gepflegt und erweitert. Sie arbeiten immer mit aktuellen Kontakten.'
    },
    {
      icon: TrendingUp,
      title: 'Mehr Erfolg',
      description: 'Qualifizierte Leads bedeuten höhere Conversion-Raten. Investieren Sie Ihre Zeit in die richtigen Kontakte.'
    },
    {
      icon: Mail,
      title: 'E-Mail-Garantie',
      description: 'Bis zu 95% unserer Kontakte haben eine gültige E-Mail-Adresse – perfekt für Ihr E-Mail-Marketing.'
    }
  ];

  return (
    <section ref={ref} className="py-24 bg-[#FAF3E0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Funktionen, die überzeugen
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Adloc bietet Ihnen alle Tools, die Sie für erfolgreiches B2B-Marketing brauchen – 
            einfach, schnell und zuverlässig.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.05 * index }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#2835F7] to-[#1a25c9] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <feature.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;